import { Component, OnInit, SecurityContext } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer } from '@angular/platform-browser';
import { PopupService } from '../../shared/modal/popup.service';
import { ParamContext } from '../../shared/service/param.context';
import { BREEDING_METHODS_BROWSER_DEFAULT_URL, INVENTORY_DETAILS_URL } from '../../app.constants';
import { UrlService } from '../../shared/service/url.service';

@Component({
    selector: 'jhi-breeding-method-manager',
    template: `
		<div class="modal-header">
			<h4 class="modal-title fw-bold">
				<span jhiTranslate="breeding-method.browser.title"></span>
			</h4>
			<button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
					(click)="close()">
			</button>
		</div>
		<div class="modal-body">
			<iframe [src]="safeUrl" style="border: 0" width="100%" height="650"></iframe>
		</div>
    `
})
export class BreedingMethodManagerComponent implements OnInit {
    safeUrl: string;

    constructor(private route: ActivatedRoute,
                public activeModal: NgbActiveModal,
                private sanitizer: DomSanitizer) {
    }

    ngOnInit(): void {
    }

    close() {
        this.activeModal.close();
    }
}

@Component({
    selector: 'jhi-breeding-method-manager-popup',
    template: ''
})
export class BreedingMethodManagerPopupComponent implements OnInit {

    constructor(private route: ActivatedRoute,
                private popupService: PopupService,
                private sanitizer: DomSanitizer,
                private paramContext: ParamContext,
                private urlService: UrlService) {
    }

    ngOnInit(): void {
        const params = '?programId=' + this.paramContext.selectedProjectId;

        const modal = this.popupService.open(BreedingMethodManagerComponent as Component, { modalDialogClass: 'modal-autofit' });
        modal.then((modalRef) => {
            const urlStr = this.urlService.buildSafeUrl(BREEDING_METHODS_BROWSER_DEFAULT_URL + params);
            modalRef.componentInstance.safeUrl = urlStr !== null
                ? this.sanitizer.bypassSecurityTrustResourceUrl(urlStr)
                : this.sanitizer.bypassSecurityTrustResourceUrl('about:blank');
        });
    }

}
